import { Link } from "react-router-dom";
import { EVENT, NAV } from "@/data/siteData";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-zinc-200">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-12 gap-y-10 md:gap-10">
          <div className="col-span-12 md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 bg-[#002FA7] text-white font-display flex items-center justify-center">
                BoT
              </span>
              <div>
                <div className="font-display text-lg tracking-tight">BoT Summit</div>
                <div className="overline text-zinc-500 mt-0.5">{EVENT.edition}</div>
              </div>
            </div>
            <p className="mt-6 text-sm text-zinc-400 max-w-sm leading-relaxed">
              The annual gathering for the people building, defending and regulating
              the infrastructure of the internet.
            </p>
            <div className="mt-8 overline text-zinc-500">London — Dubai — Bengaluru — Singapore</div>
          </div>

          <div className="col-span-6 md:col-span-3">
            <div className="overline text-zinc-500 mb-4">Explore</div>
            <ul className="space-y-3">
              {NAV.slice(0, 4).map((n) => (
                <li key={n.id}>
                  <a
                    href={`#${n.id}`}
                    data-testid={`footer-nav-${n.id}`}
                    className="text-sm hover:text-white text-zinc-300"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 md:col-span-2">
            <div className="overline text-zinc-500 mb-4">Attend</div>
            <ul className="space-y-3">
              {NAV.slice(4).map((n) => (
                <li key={n.id}>
                  <a
                    href={`#${n.id}`}
                    className="text-sm hover:text-white text-zinc-300"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-12 md:col-span-2">
            <div className="overline text-zinc-500 mb-4">Social</div>
            <ul className="space-y-3 text-sm text-zinc-300">
              <li><a href="https://www.facebook.com/profile.php?id=61566199857689" target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" className="hover:text-white">Facebook ↗</a></li>
              <li><a href="https://www.instagram.com/botsummits/" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="hover:text-white">Instagram ↗</a></li>
              <li><a href="https://www.linkedin.com/company/bot-summit/" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="hover:text-white">LinkedIn ↗</a></li>
              <li><a href="#" className="hover:text-white">YouTube ↗</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-zinc-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="overline text-zinc-500">
            © 2026 BoT Summit. All rights reserved.
          </div>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 overline text-zinc-500">
            <Link to="/sponsorship" data-testid="footer-sponsorship" className="hover:text-white">Sponsorship</Link>
            <Link to="/payment-terms" data-testid="footer-payment-terms" className="hover:text-white">Payment Terms</Link>
            <Link to="/code-of-conduct" data-testid="footer-coc" className="hover:text-white">Code of Conduct</Link>
            <Link to="/privacy" data-testid="footer-privacy" className="hover:text-white">Privacy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
